var map = {
	"./47.png": "a62d",
	"./aceite.png": "314e",
	"./barra energetica.png": "a3fb",
	"./belleza.png": "4951",
	"./capsula, tableta, gragea, comprimido, perla, pastilla, gomita.png": "da48",
	"./champu vaginal.png": "2b5a",
	"./champu.png": "4b7f",
	"./chicle, dulce o paleta de caramelo.png": "1951",
	"./crema corporal.png": "301a",
	"./crema o unguento oftalmico.png": "bcf9",
	"./crema vaginal.png": "94e0",
	"./crema y ovulos vaginales.png": "4fc8",
	"./crema, pomada, gel, pasta o ungüento dermico.png": "3164",
	"./desodorante perfumado.png": "4a9f",
	"./dispositivo inhalador polvo.png": "9615",
	"./dispositivo inhalador spray.png": "83da",
	"./dispositivo medico.png": "15d9",
	"./emulsion.png": "9110",
	"./gotas o spray nasal.png": "2657",
	"./gotas oftalmicas.png": "6881",
	"./gotas orales.png": "f358",
	"./gotas oticas.png": "e80e",
	"./granulado sobres.png": "6c62",
	"./granulado.png": "e126",
	"./inyectable en frasco ampula o ampoyeta.png": "3c69",
	"./jabon en barra.png": "e91d",
	"./jalea, miel o pulpa.png": "6194",
	"./material de curacion, botiquin.png": "db1b",
	"./ortopedia.png": "4581",
	"./ovulos o tabletas vaginales.png": "0343",
	"./parche medicado.png": "e412",
	"./pasta dental.png": "f8a0",
	"./pieza.png": "3a68",
	"./polvo sobres.png": "d0c0",
	"./polvo.png": "e070",
	"./solucion bucofaringea.png": "1304",
	"./solucion dermica.png": "913a",
	"./solucion endovenosa.png": "3b2e",
	"./solucion o aceite ingerible en ampoyeta.png": "d7e3",
	"./solucion o jabon liquido dermico.png": "bd2e",
	"./solucion para nebulizacion.png": "915e",
	"./solucion rectal.png": "76b6",
	"./solucion vaginal.png": "0b29",
	"./spray bucofaringeo.png": "1985",
	"./spray dermico.png": "9937",
	"./supositorio rectal.png": "d6cc",
	"./suspension, jarabe, solucion,elixir, liquido.png": "27fb",
	"./tableta efervecente o dispersable.png": "f591",
	"./tableta sublingual u orodispersable.png": "f594",
	"./talco o polvo dermico.png": "6a90"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4add";